import { createFeatureSelector, createSelector } from "@ngrx/store";
import { NPSHFeatureKey } from "./npsh-chart.reducer";

export const selectNPSHState = createFeatureSelector(NPSHFeatureKey);

export const selectNPSH = createSelector(
  selectNPSHState,
  (state: any) => state
);